// /**
//  * parcel - Add
//  */

// React
import React, { useContext, useEffect, useState } from 'react';
import { useDebounce } from 'use-lodash-debounce';

// react hook form
import { useForm } from 'react-hook-form';

// UI
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  Typography,
  FormControl,
  FormHelperText,
  Divider,
} from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import throttle from 'lodash/throttle';

import fulfillmentVariantsRepository from 'client-sdk/src/Repository/fulfillment-variants-repository';

// Client SDK
import Client from 'client-sdk/src/client';
import {
  GetAllProductsRequestBuilder,
  GetPartnerCategoriesRequestBuilder,
  GetVariantsRequestBuilder,
} from 'client-sdk/src/products/products';

// Type
import { AddItemCreateParcel } from '../../parcels/interfaces';
import {
  CategoryObject,
  Variant,
  VariantFeature,
} from '../../products/interfaces';
import { Product } from '../../products/interfaces';

// helpers'
import { convertPersianDigit2English } from '../../../utils/helpers';
import AuthContext from '../../../authContext';
import List from '../../parcelsSender/components/Add/variantFeaturesList';
import handleError from '../../../utils/handleError';
import theme from '../../../theme';
import Modal from '../../../components/Modal';

type Props = {
  addItem: (body: AddItemCreateParcel) => void;
  fulfillmentService: number | null;
  fulfillmentLineId: number | null;
  onClose: () => void;
};

type Inputs = {
  count: number;
  product: string;
  categoryName: string;
  productCode: number;
  countOfBox: number;
  boxCount: number;
  variant: string;
  variantCode: number;
  fulfillmentVariantCode: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& MuiDialogActions-root': {
        paddingBottom: 'none',
      },
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const token = localStorage.getItem('token') || '';

const filter = createFilterOptions<Product>();

export default function Add(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const { register, handleSubmit, errors, setValue, getValues, reset, watch } =
    useForm<Inputs>();

  const [valueVariant, setValueVariant] = React.useState<Variant | null>(null);
  const [inputValueVariant, setInputValueVariant] = React.useState('');
  const [optionsVariants, setOptionsVariant] = React.useState<Variant[]>([]);
  const [optionsVariantFeatures, setOptionsVariantFeatures] = React.useState<
    VariantFeature[]
  >([]);
  const loadingVariants = React.useRef(false);
  const [
    openFulfillmentVariantCreateDialog,
    setOpenFulfillmentVariantCreateDialog,
  ] = useState(false);
  const [fulfillmentVariantCode, setFulfillmentVariantCode] = useState('');
  const [fulfillmentVariant, setFulfillmentVariant] = useState({});
  const [valueProduct, setValueProduct] = React.useState<Product | null>(null);
  const [inputValueProduct, setInputValueProduct] = React.useState('');
  const [optionsProduct, setOptionsProduct] = React.useState<Product[]>([]);
  const [variantRequest, setVariantRequest] = React.useState(false);
  const [valueCategory, setValueCategory] =
    React.useState<CategoryObject | null>(null);
  const [inputValueCategory, setInputValueCategory] = React.useState('');
  const [optionsCategory, setOptionsCategory] = React.useState<
    CategoryObject[]
  >([]);

  const debouncedValue = useDebounce(watch('productCode'), 1000);

  const loadingProduct = React.useRef(false);

  useEffect(() => {
    if (!valueCategory) {
      setValueProduct(null);
      setValueVariant(null);
    }
  }, [valueCategory]);

  if (typeof window !== 'undefined' && !loadingVariants.current) {
    loadingVariants.current = true;
  }

  if (typeof window !== 'undefined' && !loadingVariants.current) {
    loadingProduct.current = true;
  }

  const fetchVariants = React.useMemo(
    () =>
      throttle(
        (
          request: { input: number; product: object },
          callback: (results?: Variant[]) => void
        ) => {
          let params: any = { size: 100 };
          if (request.input) {
            params = {};
          }
          (async () => {
            const makeRequest = new GetVariantsRequestBuilder()
              .id(request.input)
              .params(params)
              .build();
            const client = new Client(token);
            const response = await client.execute(makeRequest);
            const variants = response.data.content as any;
            callback(variants);
          })();
        },
        200
      ),
    [valueProduct]
  );

  const fetchProducts = React.useMemo(
    () =>
      throttle(
        (
          request: { input: string; category: object; filters: object },
          callback: (results?: Product[]) => void
        ) => {
          const { input, category, filters } = request;
          (async () => {
            const params = category?.id
              ? category?.id == 0
                ? {
                  'name.contains': input,
                  'partnerId.equals': authContext?.user?.partnerId,
                  'categoryId.specified': false,
                  size: 2000,
                  ...filters,
                }
                : {
                  'name.contains': input,
                  'partnerId.equals': authContext?.user?.partnerId,
                  'categoryId.equals': category?.id,
                  size: 2000,
                  ...filters,
                }
              : {
                'name.contains': input,
                'partnerId.equals': authContext?.user?.partnerId,
                size: 2000,
                ...filters,
              };
            const makeRequest = new GetAllProductsRequestBuilder()
              .params(params)
              .build();
            const client = new Client(token);
            const response = await client.execute(makeRequest);
            const products = response.data as any;
            callback(products);
          })();
        },
        200
      ),
    []
  );

  React.useEffect(() => {
    let active = true;
    const partnerId = authContext?.user?.partnerId;
    if (
      inputValueProduct === '' &&
      (partnerId || authContext.user.role === 'SELLER_ADMIN') &&
      valueCategory
    ) {
      setOptionsProduct(valueProduct ? [valueProduct] : []);

      (async () => {
        const params = valueCategory.id
          ? {
            size: 10000,
            'partnerId.equals': authContext?.user?.partnerId || null,
            'categoryId.equals': valueCategory.id || null,
          }
          : {
            size: 10000,
            'partnerId.equals': authContext?.user?.partnerId || null,
            'categoryId.specified': 'false',
          };
        const makeRequest = new GetAllProductsRequestBuilder()
          .params(params)
          .build();
        const client = new Client(token);
        const response = await client.execute(makeRequest);
        const product = response.data as any;
        if (active) {
          setOptionsProduct(product as Product[]);
        }
      })();

      return undefined;
    }

    if (partnerId) {
      fetchProducts(
        { input: inputValueProduct, category: valueCategory },
        (results?: Product[]) => {
          if (active) {
            let newOptions = [] as Product[];

            if (valueProduct) {
              newOptions = [valueProduct];
            }

            if (results) {
              newOptions = [...newOptions, ...results];
            }

            setOptionsProduct(newOptions);
          }
        }
      );
    } else if (!valueCategory) {
      setOptionsProduct([]);
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      setValueProduct('');
    }

    return () => {
      active = false;
    };
  }, [
    valueCategory,
    inputValueCategory,
    valueProduct,
    inputValueProduct,
    fetchProducts,
  ]);

  React.useEffect(() => {
    let active = true;
    const partnerId = authContext?.user?.partnerId;
    if (partnerId && valueVariant) {
      setOptionsProduct(valueProduct ? [valueProduct] : []);
      (async () => {
        const makeRequest = new GetVariantsRequestBuilder()
          .id(valueVariant?.id)
          .params({
            size: 100,
            'productId.equals': valueProduct?.id,
            'partnerId.equals': authContext?.user?.partnerId || null,
          })
          .build();
        const client = new Client(token);
        const response = await client.execute(makeRequest);
        const features = response.data.features as any;
        if (active) {
          setOptionsVariantFeatures(features as VariantFeature[]);
        }
      })();

      return undefined;
    }

    if (!valueVariant) {
      setOptionsVariantFeatures([]);
    }

    return () => {
      active = false;
    };
  }, [inputValueVariant, valueVariant]);

  const fetchCategories = React.useMemo(
    () =>
      throttle(
        (
          request: { input: string },
          callback: (results?: CategoryObject[]) => void
        ) => {
          (async () => {
            const makeRequest = new GetPartnerCategoriesRequestBuilder()
              .params({
                'partnerId.equals': authContext?.user?.partnerId
                  ? authContext?.user?.partnerId
                  : undefined,
                size: 100,
              })
              .build();
            const client = new Client(token);
            const response = await client.execute(makeRequest);
            const products = response.data as any;
            callback(products);
          })();
        },
        200
      ),
    []
  );

  React.useEffect(() => {
    const categoryWithoutName = optionsCategory.find(
      el => el.name === 'بدون دسته بندی'
    );
    if (!categoryWithoutName) {
      optionsCategory.push({ id: 0, name: 'بدون دسته بندی', code: 0 });
    }
    reset('product', '');
    setValueProduct('');
  }, [optionsCategory]);

  useEffect(() => {
    let active = true;
    if (
      getValues()?.productCode &&
      valueProduct?.code !== getValues()?.productCode
    ) {
      const params = getValues()?.productCode
        ? {
          input: inputValueProduct,
          category: valueCategory,
          filters: { 'code.equals': getValues()?.productCode },
        }
        : { input: inputValueProduct, category: valueCategory };
      fetchProducts(params, (results?: Product[]) => {
        setValueVariant(null);
        if (active) {
          let newOptions = [] as Product[];

          if (valueProduct) {
            newOptions = [valueProduct];
          }

          if (results) {
            newOptions = [...newOptions, ...results];
          }

          if (results?.length === 1) {
            setValueProduct(results[0]);
            setInputValueProduct(results[0].name);
          }
          if (results?.length === 0) setValueProduct({} as Product);

          setOptionsProduct(newOptions);
        }
      });
    }
    return () => {
      active = false;
    };
  }, [debouncedValue]);

  useEffect(() => {
    if (valueProduct?.code) {
      setValue('productCode', valueProduct.code);
    }
  }, [valueProduct]);

  React.useEffect(() => {
    let active = true;
    const partnerId = authContext?.user?.partnerId;
    if (inputValueCategory === '' && partnerId) {
      setOptionsCategory(valueCategory ? [valueCategory] : []);

      (async () => {
        const makeRequest = new GetPartnerCategoriesRequestBuilder()
          .params({
            size: 1000,
            'partnerId.equals': authContext?.user?.partnerId || null,
          })
          .build();
        const client = new Client(token);
        const response = await client.execute(makeRequest);
        const category = response.data as any;
        if (active) {
          setOptionsCategory(category as CategoryObject[]);
        }
      })();

      return undefined;
    }

    if (partnerId || authContext.user.role === 'SELLER_ADMIN') {
      fetchCategories(
        { input: inputValueVariant },
        (results?: CategoryObject[]) => {
          if (active) {
            let newOptions = [] as CategoryObject[];

            if (valueCategory) {
              newOptions = [valueCategory];
            }

            if (results) {
              newOptions = [...newOptions, ...results];
            }
            setOptionsCategory(newOptions);
          }
        }
      );
    }

    return () => {
      active = false;
    };
  }, [valueCategory, inputValueCategory]);
  // fetchCategories

  React.useEffect(() => {
    let active = true;

    if (valueProduct?.id) {
      setOptionsVariant(valueVariant ? [valueVariant] : []);

      (async () => {
        const makeRequest = new GetVariantsRequestBuilder()
          .params({
            'productId.equals': valueProduct?.id,
            size: 100,
          })
          .build();
        const client = new Client(token);
        const response = await client.execute(makeRequest);
        const variant = response.data.content as any;
        if (variant.length == 1) {
          setValueVariant(variant[0]);
        }
        setVariantRequest(true);
        if (active) {
          setOptionsVariant(variant as Variant[]);
        }
      })();
      return undefined;
    } else if (!valueProduct) {
      setOptionsVariant([]);
      setValueVariant('');
      setVariantRequest(false);
      setFulfillmentVariant('');
      setValue('variantCode', '');
      setValue('fulfillmentVariantCode', '');
    } 

    return () => {
      active = false;
    };
  }, [valueProduct]);

  useEffect(() => {
    if (optionsVariants.length && !valueVariant && !fulfillmentVariant) {
      setValue('variantCode', '');
      setValue('fulfillmentVariantCode', '');
    }
    if (optionsVariants.length !== 0 && !valueVariant) {
      setOpenFulfillmentVariantCreateDialog(false);
    }
  }, [optionsVariants]);

  const onSubmit = (data: any) => {
    const {
      count,
      countOfBox,
      boxCount,
      productCode,
      variantCode,
      fulfillmentVariantCode,
    } = data;
    props.addItem({
      count: convertPersianDigit2English(count),
      boxCount,
      productCode,
      countOfBox,
      fulfillmentVariantCode,
      variantCode: variantCode ? variantCode : undefined,
      variant: valueVariant ? valueVariant : undefined,
      product: valueProduct,
      category: valueCategory,
    });
  };

  const flattVariants = (item: any) => {
    const descriptionArray: string[] = [];

    item.forEach((el: { key: string; value: string }) => {
      descriptionArray.push(`${el.key}: ${el.value}`);
    });
    return descriptionArray.join(',').substring(0, 40) + '...';
  };

  const getFulfillmentVariants = async (action: any) => {
    const payload = { ...action };
    try {
      const { response } =
        await fulfillmentVariantsRepository.getFulfillmentVariants({
          payload,
        });
      setFulfillmentVariant(response.data[0]);
      if (response.data.length === 0)
        setOpenFulfillmentVariantCreateDialog(true);
    } catch (error) {
      handleError(error);
    }
  };

  const createFulfillmentVariants = async (action: any) => {
    const payload = { ...action };
    try {
      const { response, callback } =
        await fulfillmentVariantsRepository.createFulfillmentVariants({
          payload,
        });
      setFulfillmentVariant(response.data);
      callback && callback();
    } catch (error) {
      handleError(error);
    }
  };

  const submitFulfillmentVariants = () => {
    let params: any = {
      code: fulfillmentVariantCode,
      fulfillmentLineId: props.fulfillmentLineId,
      productId: valueProduct?.id,
      callback: () => setOpenFulfillmentVariantCreateDialog(false),
    };
    if (valueVariant) {
      params = {
        code: fulfillmentVariantCode,
        fulfillmentLineId: props.fulfillmentLineId,
        skuId: valueVariant?.id,
        callback: () => setOpenFulfillmentVariantCreateDialog(false),
      };
    }
    createFulfillmentVariants(params);
  };

  useEffect(() => {
    if (!!props.fulfillmentService && valueVariant) {
      getFulfillmentVariants({
        fulfillmentLineId: { equals: props.fulfillmentLineId },
        skuId: { equals: valueVariant?.id },
      });
    }
  }, [props.fulfillmentLineId, props.fulfillmentService, valueVariant]);

  useEffect(() => {
    if (fulfillmentVariant) {
      setValue('fulfillmentVariantCode', fulfillmentVariant.code);
    }
  }, [fulfillmentVariant]);

  useEffect(() => {
    if (!valueVariant) {
      setVariantRequest(false);
    }
  }, [valueVariant]);

  useEffect(() => {
    if (
      !!props.fulfillmentService &&
      props.fulfillmentLineId &&
      valueProduct &&
      optionsVariants.length === 0 &&
      variantRequest
    ) {
      setOpenFulfillmentVariantCreateDialog(true);
    }
  }, [
    props.fulfillmentLineId,
    props.fulfillmentService,
    optionsVariants,
    valueProduct,
  ]);

  useEffect(() => {
    if (
      !valueVariant &&
      fulfillmentVariant &&
      optionsVariants.length === 0 &&
      !openFulfillmentVariantCreateDialog
    ) {
      if (inputValueVariant === '' && valueProduct?.id) {
        setOptionsVariant(valueVariant ? [valueVariant] : []);

        (async () => {
          const makeRequest = new GetVariantsRequestBuilder()
            .params({
              'productId.equals': valueProduct?.id,
              size: 100,
            })
            .build();
          const client = new Client(token);
          const response = await client.execute(makeRequest);
          const variant = response.data.content as any;

          setOptionsVariant(variant as Variant[]);
        })();
        return undefined;
      }
    }
  }, [
    valueVariant,
    fulfillmentVariant,
    optionsVariants,
    openFulfillmentVariantCreateDialog,
  ]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
          container
          spacing={2}
          alignItems="flex-start"
          style={{ paddingBottom: '0' }}
        >
          <Grid container item xs={12} md={6} alignItems="flex-end">
            <div className={classes.item}>
              <span style={{ width: '100%' }}>
                <FormControl style={{ width: '100%' }}>
                  <Autocomplete
                    id="category"
                    getOptionLabel={option =>
                      typeof option === 'string' ? option : option.name
                    }
                    filterOptions={(options, params: any) => {
                      const filtered = filter(options, params) as any;
                      return filtered;
                    }}
                    options={optionsCategory}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    noOptionsText="دسته‌بندی موجود نیست"
                    disabled={!optionsCategory.length}
                    value={valueCategory}
                    onChange={(event: any, newValue: CategoryObject | null) => {
                      setOptionsCategory(
                        newValue
                          ? [newValue, ...optionsCategory]
                          : optionsCategory
                      );
                      setValueCategory(newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      setInputValueCategory(newInputValue);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        name="category"
                        label="دسته بندی"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    renderOption={option => {
                      return (
                        <Grid container alignItems="center">
                          <Grid item xs>
                            {option.name}
                          </Grid>
                        </Grid>
                      );
                    }}
                  />
                </FormControl>
              </span>
            </div>
          </Grid>
          <Grid container item xs={12} md={6} alignItems="flex-end">
            <div className={classes.item}>
              <span style={{ width: '100%' }}>
                <FormControl style={{ width: '100%' }}>
                  <Autocomplete
                    id="products"
                    getOptionLabel={option =>
                      typeof option === 'string' ? option : option.name
                    }
                    getOptionSelected={(option, value) =>
                      option.name === value.name
                    }
                    filterOptions={(options, params: any) => {
                      const filtered = filter(options, params) as any;
                      return filtered;
                    }}
                    options={optionsProduct}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    noOptionsText="کالایی وجود ندارد"
                    // disabled={!inputValueCategory}
                    value={valueProduct}
                    onChange={(event: any, newValue: Product | null) => {
                      setOptionsProduct(
                        newValue
                          ? [newValue, ...optionsProduct]
                          : optionsProduct
                      );
                      setValueProduct(newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      setInputValueProduct(newInputValue);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="نام کالا"
                        name="product"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    renderOption={option => {
                      return (
                        <Grid container alignItems="center">
                          <Grid item xs>
                            {option.name}
                          </Grid>
                        </Grid>
                      );
                    }}
                  />
                </FormControl>
              </span>
            </div>
          </Grid>
          <Grid container item xs={12} md={6}>
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  id="productCode"
                  name="productCode"
                  InputLabelProps={{
                    shrink: !!valueProduct || !!getValues().productCode,
                  }}
                  label="کد کالا"
                  inputRef={register({ required: true })}
                  error={errors.productCode && true}
                />
                <FormHelperText error focused>
                  {errors.productCode && 'انتخاب کالا الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid container item xs={12} md={6}>
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <FormControl style={{ width: '100%' }}>
                  <Autocomplete
                    id="variantCode"
                    getOptionLabel={option =>
                      typeof option === 'string' ? option : String(option.code)
                    }
                    filterOptions={x => x}
                    options={optionsVariants}
                    autoComplete
                    includeInputInList
                    disabled={
                      !inputValueProduct || optionsVariants.length === 0
                    }
                    filterSelectedOptions
                    noOptionsText="تنوع کالایی وجود ندارد"
                    value={valueVariant}
                    onChange={(event: any, newValue: Variant | null) => {
                      setOptionsVariant(
                        newValue
                          ? [newValue, ...optionsVariants]
                          : optionsVariants
                      );
                      setValueVariant(newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      setInputValueVariant(newInputValue);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        name="variantCode"
                        label="کد تنوع کالا"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    renderOption={option => {
                      return (
                        <Grid container alignItems="center">
                          <Grid item xs>
                            {option.code}
                            <Typography variant="body2" color="textSecondary">
                              {option.features && option.features.length > 0
                                ? flattVariants(option.features)
                                : '-'}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    }}
                  />
                </FormControl>
              </div>
            </div>
          </Grid>
          <Grid container item xs={12} md={6} alignItems="flex-end">
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  id="variant"
                  name="variant"
                  value={valueVariant?.id}
                  disabled={optionsVariants.length === 0}
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: !!valueVariant,
                  }}
                  label="شناسه تنوع کالا"
                  inputRef={register({ required: optionsVariants.length > 1 })}
                  error={errors.variantCode}
                />
                <FormHelperText error focused>
                  {errors.variantCode && 'کد تنوع کالا الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>

          <Grid container item xs={12} md={6} alignItems="flex-end">
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  id="count"
                  name="count"
                  label="تعداد"
                  inputRef={register({ required: true, pattern: /[0-9]/ })}
                  error={errors.count && true}
                />
                <FormHelperText error focused>
                  {errors.count?.type === 'required' && 'تعداد کالا الزامی میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.count?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          {!!props.fulfillmentService && (
            <Grid container item xs={12} md={12} alignItems="flex-end">
              <div className={classes.item}>
                <div style={{ width: '100%' }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    id="fulfillmentVariantCode"
                    name="fulfillmentVariantCode"
                    disabled={optionsVariants.length === 0}
                    InputLabelProps={{
                      shrink: !!getValues().fulfillmentVariantCode,
                    }}
                    label="کد مرکز پردازش"
                    inputRef={register({ required: optionsVariants.length > 1 })}
                    error={errors.fulfillmentVariantCode}
                  />
                  <FormHelperText error focused>
                    {errors.fulfillmentVariantCode &&
                      'کد مرکز پردازش الزامی میباشد'}
                  </FormHelperText>
                </div>
              </div>
            </Grid>
          )}
          <>
            {optionsVariantFeatures.length ? (
              <Grid container style={{ marginTop: '20px', marginBottom: '10px' }}>
                <List modal={true} data={optionsVariantFeatures} />
              </Grid>
            ) : null}
          </>
          <Divider
            style={{
              margin: '10px auto 15px auto',
              width: '97%',

              alignItems: 'center',
            }}
          />
          <Grid container md={12} style={{ padding: '0 7px' }}>
            <Grid
              container
              item
              md={9}
              style={{
                alignItems: 'center',
                marginBottom: '-2px',
                paddingBottom: '0',
              }}
            >
              {/* <Typography>ایجاد کالای جدید</Typography> */}
            </Grid>
            <Grid
              container
              item
              md={3}
              style={{
                alignItems: 'center',
                marginBottom: '-2px',
                paddingBottom: '0',
              }}
            >
              <Button
                style={{ marginRight: 'auto' }}
                type="submit"
                size="medium"
                id="submitAddProduct"
                autoFocus
                variant="contained"
                color="primary"
                disabled={!inputValueProduct}
              >
                {'افزودن کالا'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
      {/* <Modal
        maxWidth="md"
        onClose={() => setOpenFulfillmentVariantCreateDialog(false)}
        open={openFulfillmentVariantCreateDialog}
        content={
          <Grid container spacing={3} style={{ width: '100%', margin: 0 }}>
            <Grid style={{ width: '100%', margin: 0 }} container spacing={3}>
              <div className={classes.item}>
                <span style={{ width: '100%' }}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="code"
                    name="code"
                    label="کد مرکز پردازش"
                    value={fulfillmentVariantCode}
                    onChange={e => setFulfillmentVariantCode(e.target.value)}
                    inputRef={register({ required: true })}
                    error={errors.count && true}
                  />
                </span>
              </div>
            </Grid>
            <Grid
              container
              style={{ margin: '20px 0' }}
              spacing={3}
              justify="flex-end"
            >
              <Button
                fullWidth
                type="button"
                size="large"
                id="submit"
                autoFocus
                variant="contained"
                color="secondary"
                disabled={!fulfillmentVariantCode}
                onClick={submitFulfillmentVariants}
              >
                {'ثبت'}
              </Button>
            </Grid>
          </Grid>
        }
      /> */}
    </>
  );
}